module.exports = __webpack_public_path__ + "media/11_ASANBUDAPEST-Atmosphere11.72f813ef.mp3";